
import { AfterContentInit, Component, ElementRef, Renderer2, inject } from '@angular/core';
import { IconsEnum } from '@uigy/generated/icons.enum';
import {
  UIButtonIconComponent
} from '@uigy/shared/components/ui-button/button-icon/ui-button-icon.component';

@Component({
  selector: 'app-password-revealer',
  template: `
    <ng-content></ng-content>
    @if (passwordInput) {
      <app-ui-button-icon
        class="eye-icon-location"
        [variant]="'floating'"
        [size]="'micro'"
        [icon]="IconsEnum.show"
        [class.active]="isVisible"
        (clicked)="toggleVisibility()"
        tabindex="-1"
      ></app-ui-button-icon>
    }`,
  styles: [
    `
        :host {
            position: relative;
            display: inline-block;
        }

        .eye-icon-location {
            margin-left: -35px;
        }
    `,
  ],
  imports: [
    UIButtonIconComponent
],
})
export class PasswordRevealerComponent implements AfterContentInit {
  private elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private renderer2 = inject(Renderer2);

  protected readonly IconsEnum = IconsEnum;
  public isVisible: boolean = false;
  public passwordInput?: HTMLInputElement | null;

  ngAfterContentInit(): void {
    if (this.elementRef.nativeElement) {
      this.passwordInput = this.elementRef.nativeElement.querySelector<HTMLInputElement>('input[type="password"]');
    }
  }

  public toggleVisibility(): void {
    this.isVisible = !this.isVisible;
    this.renderer2.setAttribute(this.passwordInput, 'type', this.isVisible ? 'text' : 'password');
  }
}
